import { TableTypes } from '@/constant';
import { useGetListData, useRowSelection } from '@/hooks';
import { FooterInfoActions } from '@/stores';
import { MyPageSelectors } from '@/stores/my-page';
import { useCallback, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getColumns } from './config';
import { DataType, IProps } from './type';

export const useLogic = (props: IProps) => {
	const { canEdit, id } = props;
	const columns = useMemo(() => {
		return getColumns(canEdit).map((col) => {
			if (!col.editable) {
				return col;
			}
			return {
				...col,
				onCell: (record: DataType) => ({
					record,
					editable: col.editable,
					dataIndex: col?.dataIndex,
					title: col.title,
					cellType: col.cellType,
					inputProps: col.inputProps,
				}),
			};
		});
	}, [canEdit]);

	const { isSystemRole } = useSelector(MyPageSelectors.selectDataMyPage);

	const rowSelection = useRowSelection();

	const dispatch = useDispatch();

	const { total } = useGetListData({
		type: TableTypes.FOOTER_INFO,
	});

	const fetchData = useCallback(() => {
		dispatch(
			FooterInfoActions.getFooterInfoListRequest({
				isSystemAdmin: isSystemRole,
				unitId: id,
			})
		);
	}, [isSystemRole, id, dispatch]);

	useEffect(() => {
		fetchData();
	}, [isSystemRole, id]);

	return {
		columns,
		canEdit,
		rowSelection,
		total,
		fetchData,
	};
};
